import { createSlice } from '@reduxjs/toolkit';

const loadState = () => {
    try {
        const serializedState = localStorage.getItem('idState');
        if (serializedState === null) {
            return { hardwareId: null, softwareId: null, deviceId: null };
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return { hardwareId: null, softwareId: null, deviceId: null };
    }
};

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('idState', serializedState);
    } catch (err) {
        console.error(err);
    }
};


const clearState = () => {
    try {
        localStorage.removeItem('idState');
    } catch (err) {
        console.error(err);
    }
};

const idSlice = createSlice({
    name: 'id',
    initialState: loadState(),
    reducers: {
        setHardwareId: (state, action) => {
            state.hardwareId = action.payload;
            saveState(state);
        },
        setSoftwareId: (state, action) => {
            state.softwareId = action.payload;
            saveState(state);
        },
        setDeviceId: (state, action) => {
            state.deviceId = action.payload;
            saveState(state);
        },
        clearIds: (state) => {
            state.hardwareId = null;
            state.softwareId = null;
            state.deviceId = null;
            clearState();
        },
    },
});

export const {
        setHardwareId,
        setSoftwareId ,
        setDeviceId,
    } = idSlice.actions;

export default idSlice.reducer;
